import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const contrats = [
    {
        key: "contrats",
        path: `${APP_PREFIX_PATH}/contrats`,
        component: React.lazy(() => import("views/app-views/contrat")),
        meta: {
            permission: "LIST_CONTRAT"
        }
    },

    {
        key: "add-contrats",
        path: `${APP_PREFIX_PATH}/contrats/add`,
        component: React.lazy(() => import("views/app-views/contrat/add")),
        meta: {
            permission: "ADD_CONTRAT"
        }
    },

    {
        key: "add-contrats",
        path: `${APP_PREFIX_PATH}/contrats/:code`,
        component: React.lazy(() => import("views/app-views/contrat/show")),
        meta: {
            permission: "VIEW_CONTRAT"
        }
    },

    {
        key: "add-contrats",
        path: `${APP_PREFIX_PATH}/contrats/:code/edit`,
        component: React.lazy(() => import("views/app-views/contrat/edit")),
        meta: {
            permission: "EDIT_CONTRAT"
        }
    },
]